"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageEditHandler = void 0;
var $ = require("jquery");
var PageEditHandler = (function () {
    function PageEditHandler(initialConfig, containerSelector, addButtonSelector) {
        this.containerElem = $(containerSelector);
        this.addButton = $(addButtonSelector);
        this.table = this.populateRows(initialConfig);
        var self = this;
        $(addButtonSelector).on("click", this, function () {
            self.createPhotoRow(self.table, { photoId: "" });
        });
    }
    PageEditHandler.prototype.getResult = function () {
        var self = this;
        var result = [];
        this.table.find("tr").each(function (index, element) {
            var row = $(element);
            var input = row.find("input[data-type='photo']");
            var photoId = input.val();
            result.push({ "photoId": photoId });
        });
        return result;
    };
    PageEditHandler.prototype.populateRows = function (initialConfig) {
        var _this = this;
        this.containerElem.append("<table id='pagedataTable'/>");
        var table = $("#pagedataTable");
        initialConfig.forEach(function (row) {
            _this.createPhotoRow(table, row);
        });
        this.containerElem.append(table);
        return table;
    };
    PageEditHandler.prototype.createPhotoRow = function (table, row) {
        var tr = $(document.createElement("tr"));
        tr.append("<td><td><input type='text' size='40' value='" + row.photoId + "' data-type='photo'></td><td><a class=\"btn btn-primary btn-sm upbutton\">Up</a></td><td><a class=\"btn btn-primary btn-sm downbutton\">Down</a><td><a class=\"btn btn-danger btn-sm deletebutton\">Delete</a></td> ");
        table.append(tr);
        tr.find("a").on("click", function () {
            var b = $(this);
            var row = b.parents("tr:first");
            if (b.hasClass("upbutton")) {
                row.insertBefore(row.prev());
            }
            else if (b.hasClass("downbutton")) {
                row.insertAfter(row.next());
            }
            else if (b.hasClass("deletebutton")) {
                row.remove();
            }
        });
    };
    return PageEditHandler;
}());
exports.PageEditHandler = PageEditHandler;

//# sourceMappingURL=PageEdit.js.map
